import { FlowConsumerContextEnergy as FlowContext } from '../../context';

export const shouldSkipIfTestVariantIsActive = (context: FlowContext): boolean => {
  const { gb_variant } = context;

  return gb_variant === 'expendable_offercard';
};
